import { JSONSerializable } from '../../util/json';
import { Int } from '../numeric';
import { AccAddress, ValAddress } from '../strings';

export class UnbondingDelegation extends JSONSerializable<
  UnbondingDelegation.Data
> {
  constructor(
    public delegator_address: AccAddress,
    public validator_address: ValAddress,
    public entries: UnbondingDelegation.Entry[]
  ) {
    super();
  }

  public static fromData(data: UnbondingDelegation.Data): UnbondingDelegation {
    const { delegator_address, validator_address, entries } = data;
    return new UnbondingDelegation(
      delegator_address,
      validator_address,
      entries.map(e => UnbondingDelegation.Entry.fromData(e))
    );
  }

  public toData(): UnbondingDelegation.Data {
    const { delegator_address, validator_address, entries } = this;
    return {
      delegator_address,
      validator_address,
      entries: entries.map(e => e.toData()),
    };
  }
}

export namespace UnbondingDelegation {
  export interface Data {
    delegator_address: AccAddress;
    validator_address: ValAddress;
    entries: UnbondingDelegation.Entry.Data[];
  }

  export class Entry extends JSONSerializable<Entry.Data> {
    constructor(
      public initial_balance: Int,
      public balance: Int,
      public creation_height: number,
      public completion_time: Date
    ) {
      super();
    }

    public toData(): Entry.Data {
      return {
        initial_balance: this.initial_balance.toString(),
        balance: this.balance.toString(),
        creation_height: this.creation_height.toFixed(),
        completion_time: this.completion_time.toISOString(),
      };
    }

    public static fromData(data: Entry.Data): Entry {
      const {
        initial_balance,
        balance,
        creation_height,
        completion_time,
      } = data;
      return new Entry(
        new Int(initial_balance),
        new Int(balance),
        Number.parseInt(creation_height),
        new Date(completion_time)
      );
    }
  }

  export namespace Entry {
    export interface Data {
      initial_balance: string;
      balance: string;
      creation_height: string;
      completion_time: string;
    }
  }
}
